"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Title = _interopRequireDefault(require("../../Title"));
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function index(props) {
  var style = props.style,
    flexTitle = props.flexTitle,
    description = props.description,
    _a = props.configuration,
    configuration = _a === void 0 ? [] : _a,
    tab = props.tab,
    title = props.title;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-card-container",
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-card-wrap"
  }, flexTitle && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: description
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-card-small-title"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "package-card-main",
    style: tab ? {
      marginBottom: 40,
      marginLeft: 0,
      marginRight: 0
    } : {}
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    var title = item.title,
      desc = item.desc,
      content = item.content,
      btnTxt = item.btnTxt,
      colorTheme = item.colorTheme,
      tagTxt = item.tagTxt,
      onCallback = item.onCallback,
      extendProps = item.extendProps;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-card-item",
      key: index
    }, tagTxt ? ( /*#__PURE__*/_react["default"].createElement("div", {
      className: 'special-tag'
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "special-tag-txt"
    }, tagTxt))) : null, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('package-card-item-title', {
        'orange-theme': colorTheme === 'orange'
      })
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-card-item-desc"
    }, desc), /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-card-item-content"
    }, content), /*#__PURE__*/_react["default"].createElement("div", {
      className: "package-card-item-btn"
    }, /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('package-card-item-btn-txt', {
        'orange-theme': colorTheme === 'orange'
      }),
      onClick: function onClick() {
        onCallback && onCallback();
      }
    }, extendProps || {}), btnTxt)));
  }))));
}